import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=6d516150&scoped=true&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"
import style0 from "./EditMedia.vue?vue&type=style&index=0&id=6d516150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d516150",
  null
  
)

export default component.exports